var map = {
	"./cbwc-1.jpg": 9110,
	"./cbwc-2.jpg": 9457,
	"./cbwc-3.jpg": 1412,
	"./cbwc-4.jpg": 6351,
	"./cbwc-5.jpg": 3970,
	"./cbwc-6.jpg": 3869,
	"./cbwc-7.jpg": 2736,
	"./cbwc-8.jpg": 1083,
	"./cbwc-9.jpg": 9598,
	"./cbwc-feedback.png": 782,
	"./cbwc-yuwantar.jpg": 2398,
	"./gunjan-1.jpg": 7482,
	"./gunjan-2.jpg": 3733,
	"./hgatm-1.png": 7390,
	"./hgatm-2.png": 9189,
	"./hgatm-3.jpg": 6728,
	"./pratidhwani-1.jpg": 8258,
	"./pride-1.jpg": 2737,
	"./yuwantar-1.jpg": 7658,
	"./yuwantar-2.jpg": 8149,
	"./yuwantar-3.jpg": 6968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2609;